<template>
  <basic-container>汇款审核管理</basic-container>
</template>

<script>
export default {
  name: "remittanceAudit"
};
</script>

<style>
</style>